import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase URL or Anon Key. Check your .env file.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: false // For public dashboard, we don't need to persist auth
  }
});

// Function to get revenue by energy source
export const getRevenueBySource = async () => {
  const { data, error } = await supabase
    .from('public_revenue_by_source')
    .select('*');
  
  if (error) {
    console.error('Error fetching revenue by source:', error);
    throw error;
  }
  
  return data;
};

// Function to get monthly trends
export const getMonthlyTrends = async () => {
  const { data, error } = await supabase
    .from('public_monthly_trends')
    .select('*');
  
  if (error) {
    console.error('Error fetching monthly trends:', error);
    throw error;
  }
  
  return data;
};

// Function to get hedge performance
export const getHedgePerformance = async () => {
  const { data, error } = await supabase
    .from('public_hedge_performance')
    .select('*');
  
  if (error) {
    console.error('Error fetching hedge performance:', error);
    throw error;
  }
  
  return data;
};

// Function to get regional performance
export const getRegionalPerformance = async () => {
  const { data, error } = await supabase
    .from('public_regional_performance')
    .select('*');
  
  if (error) {
    console.error('Error fetching regional performance:', error);
    throw error;
  }
  
  return data;
};
